import React from 'react';

const GhostLogo = ({ isVisible, showText, showIcon }) => {
  return (
    <div className={`ghost-logo ${isVisible ? 'visible' : ''}`}>
      <div className={`ghost-icon ${showIcon ? 'visible' : ''}`}>
        <svg width="32" height="32" viewBox="0 0 100 100" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path 
            d="M50 15C34.536 15 22 27.536 22 43V75C22 78.314 24.686 81 28 81C31.314 81 34 78.314 34 75V70C34 66.686 36.686 64 40 64C43.314 64 46 66.686 46 70V75C46 78.314 48.686 81 52 81C55.314 81 58 78.314 58 75V70C58 66.686 60.686 64 64 64C67.314 64 70 66.686 70 70V75C70 78.314 72.686 81 76 81C79.314 81 82 78.314 82 75V43C82 27.536 69.464 15 50 15Z" 
            fill="none"
            stroke="#d1d5db"
            strokeWidth="5"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <circle cx="40" cy="40" r="4" fill="#d1d5db"/>
          <circle cx="60" cy="40" r="4" fill="#d1d5db"/>
        </svg>
      </div>
      <div className={`ghost-text ${showText ? 'visible' : ''}`}>GhostWrite</div>
    </div>
  );
};

export default GhostLogo; 